// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1ImOO","colMaxWidth":"Table_colMaxWidth__1VlPG"};